export const getYearsOfExperience = () => {
  const startDate = new Date('2013-10-01')
  const today = new Date()
  let years = today.getFullYear() - startDate.getFullYear()
  const m = today.getMonth() - startDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < startDate.getDate())) {
    years--
  }
  return years
}
